import SocialNetworksWidget from './social_networks';

export default SocialNetworksWidget;
